import axios from "@/config/http";
import ip from "../config/ip.js";

let base = ip.Ips.ip1;
/*=============枚举=============*/
/**
 *  优惠券获取方式
 * @returns
 */
export const couponGetTypeApi = () => {
  return axios.get(`${base}/biz/enums/coupon/getType`);
};
/**
 * 优惠券领取方式
 * @returns
 */
export const couponReceiveTypeApi = () => {
  return axios.get(`${base}/biz/enums/coupon/receiveType`);
};
/**
 *  优惠券状态
 * @returns
 */
export const couponStatusApi = () => {
  return axios.get(`${base}/biz/enums/coupon/status`);
};
/**
 * 优惠券类型
 * @returns
 */
export const couponTypeApi = () => {
  return axios.get(`${base}/biz/enums/coupon/type`);
};
/**
 * 优惠券使用状态
 * @returns
 */
export const couponUseStatusApi = () => {
  return axios.get(`${base}/biz/enums/coupon/useStatus`);
};
/**
 * 优惠券有效期类型
 * @returns
 */
export const couponValidityApi = () => {
  return axios.get(`${base}/biz/enums/coupon/validity`);
};

/**
 * 优惠券消费类型
 * @returns
 */
export const couponConsumeTypeApi = () => {
  return axios.get(`${base}/biz/enums/coupon/consumeType`);
};

/*==========================*/
/**
 * 查询
 * @param {*} params
 * @returns
 */
export const couponListApi = params =>
  axios.get(`${base}/biz/coupon/list`, { params: params });
/**
 * 查询详情
 */
export const getCouponInfoApi = id =>
  axios.get(`${base}/biz/coupon/`, { params: { id: id } });

/**
 * 保存优惠券基础信息
 * @param {*} data
 * @returns
 */
export const saveCouponInfoApi = data =>
  axios.post(`${base}/biz/coupon/save`, data);
/**
 * 获取优惠券绑定的型号
 * @param {*} id
 * @returns
 */
export const getCouponGoodsApi = id =>
  axios.get(`${base}/biz/coupon/goods`, { params: { couponId: id } });
/**
 * 保存优惠券商品
 * @param {*} id
 * @param {*} data
 * @returns
 */
export const saveCouponGoodsApi = (id, data) =>
  axios.post(`${base}/biz/coupon/goods/${id}`, data);

/**
 * 删除优惠券商品
 * @param {*} id
 * @returns
 */
export const delCouponGoodsApi = id =>
  axios.get(`${base}/biz/coupon/goods/del`, {
    params: { couponGoodsId: id }
  });

/**
 * 获取优惠券绑定的型号
 * @param {*} id
 * @returns
 */
export const getCouponModelApi = id =>
  axios.get(`${base}/biz/coupon/model`, { params: { couponId: id } });

/**
 * 保存优惠券绑定的型号
 * @param {*} id
 * @param {*} data
 * @returns
 */
export const saveCouponModelApi = (id, data) =>
  axios.post(`${base}/biz/coupon/model/${id}`, data);

/**
 * 删除优惠券绑定的型号
 * @param {*} id
 * @returns
 */
export const delCouponModelApi = id =>
  axios.get(`${base}/biz/coupon/model/del`, {
    params: { couponModelId: id }
  });
/**
 * 获取优惠券绑定的品牌
 * @param {*} id
 * @returns
 */
export const getCouponBrandApi = id =>
  axios.get(`${base}/biz/coupon/brand`, { params: { couponId: id } });

/**
 * 保存优惠券绑定的品牌
 * @param {*} id
 * @param {*} data
 * @returns
 */
export const saveCouponBrandApi = (id, data) =>
  axios.post(`${base}/biz/coupon/brand/${id}`, data);

/**
 * 删除优惠券绑定的品牌
 * @param {*} id
 * @returns
 */
export const delCouponBrandApi = id =>
  axios.get(`${base}/biz/coupon/brand/del`, {
    params: { couponBrandId: id }
  });

/**
 * 获取优惠券绑定的品类
 * @param {*} id
 * @returns
 */
export const getCouponCategoryApi = id =>
  axios.get(`${base}/biz/coupon/category`, { params: { couponId: id } });

/**
 * 保存优惠券绑定的品类
 * @param {*} id
 * @param {*} data
 * @returns
 */
export const saveCouponCategoryApi = (id, data) =>
  axios.post(`${base}/biz/coupon/category/${id}`, data);

/**
 * 删除优惠券绑定的型号
 * @param {*} id
 * @returns
 */
export const delCouponCategoryApi = id =>
  axios.get(`${base}/biz/coupon/category/del`, {
    params: { couponCategoryId: id }
  });

/**
 * 分页查询
 * @param {*} params
 * @returns
 */
export const loadCouponPageApi = params =>
  axios.get(`${base}/biz/coupon/page`, { params: params });

/**
 * 删除
 * @param {*} id
 * @returns
 */
export const deleteCouponApi = id =>
  axios.get(`${base}/biz/coupon/delete/`, { params: { id: id } });

/**
 * 查询
 * @param {*} params .
 * @returns
 */
export const loadCouponCodePageApi = params =>
  axios.get(`${base}/biz/coupon/code/page`, { params: params });

/**
 * 生成
 *
 * @param {*} id 优惠券id
 * @param {*} num 数量
 * @returns .
 */
export const generateCouponCodeApi = (id, num) => {
  return axios.post(
    `${base}/biz/coupon/code/generate/?quantity=${num}&couponId=${id}`,
    {}
  );
};
/**
 * 发放优惠券
 * @param {*} id 优惠券id
 * @param {*} body 会员ID
 * @returns .
 */
export const publishCouponApi = (id, body) => {
  return axios.post(`${base}/biz/coupon/code/publish/${id}`, body);
};



// WEBPACK FOOTER //
// ./src/api/coupon.js